import React, { useRef, useEffect, ReactNode, ReactElement } from "react";
import styles from "./SideDrawer.module.scss";

interface DrawerProps {
  showDrawer: boolean;
  onClose?: () => void;
  children?: ReactNode;
  position?: "left" | "right"; // Optional: support left or right positioning
  headerActions?: ReactElement;
  customStyle?: React.CSSProperties;
}

const SideDrawer: React.FC<DrawerProps> = ({
  showDrawer,
  onClose,
  children,
  customStyle,
}) => {
  const drawerRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (e: React.MouseEvent) => {
    if (drawerRef.current === e.target && onClose) {
      onClose();
    }
  };

  useEffect(() => {
    if (showDrawer) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [showDrawer]);

  return (
    <>
      {showDrawer && (
        <div className={`drawer_container ${styles.drawer_container}`}>
          <div
            className={`drawer_backdrop ${styles.drawer_backdrop}`}
            onClick={handleClickOutside}
            ref={drawerRef}
          ></div>
          <div className={`drawer ${styles.drawer}`} style={customStyle}>
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default SideDrawer;
